module.exports = __webpack_public_path__ + "img/logo-old.1265ec3e.png";